/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'


export const getAllRole = createAsyncThunk('role/getAllRole', async (_, { rejectWithValue }) => {
    try {
        const data = await api.role.getAllRole()

        // Format the data to match the model
        const formattedData = data?.Records?.map(role => ({
            roleName: role.roleName,
            roleDetails: role.roleDetails.map(detail => ({
                detailValue: detail.detailValue ?? 'false',
                detailName: detail.detailName ?? ''
            })),
            username: role.username,
            roleID: role.roleID
        }));

        return Promise.resolve(formattedData);

    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getRoleHistory = createAsyncThunk('role/getRoleHistory', async (params, { rejectWithValue }) => {
    try {
        const data = await api.role.getRoleHistory(params)


        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})